<template>
  <div class="text-center">

    <!-- Información de la página -->
    <div class="mb-2">
      Mostrando
      {{ firstItem }} – {{ lastItem }} de {{ pagination.count }} registros
      (Página {{ page }} de {{ totalPages }})
    </div>

    <!-- Botones anterior / siguiente -->
    <div>
      <button
        class="btn btn-outline-primary me-2"
        :disabled="!pagination.previous"
        @click="goToPage(page - 1)"
      >
        <i class="bi bi-chevron-left"></i>
      </button>
      <button
        class="btn btn-outline-primary"
        :disabled="!pagination.next"
        @click="goToPage(page + 1)"
      >
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

interface Pagination {
  count: number
  next: string | null
  previous: string | null
  results: any[]
}

const props = defineProps<{
  pagination: Pagination
  page: number
  pageSize: number
}>()

const emit = defineEmits<{ (e: "change-page", page: number): void }>()

const totalPages = computed(() =>
  Math.ceil(props.pagination.count / props.pageSize)
)

const firstItem = computed(() =>
  props.pagination.count === 0 ? 0 : (props.page - 1) * props.pageSize + 1
)

const lastItem = computed(() =>
  Math.min(props.page * props.pageSize, props.pagination.count)
)

function goToPage(page: number) {
  if (page < 1 || page > totalPages.value || page === props.page) return
  emit("change-page", page)
}
</script>

<style scoped>
.btn[disabled] {
  cursor: default;
  opacity: 0.6;
}
</style>
